export default __webpack_public_path__ + "static/media/Beetroot Velvet Latte - proportioned_170.6027a30f.jpg";